import { Box, Card, CardActionArea, CardContent, Chip, Popover, Typography } from "@mui/material";
import { WIZARD_STEP_ICONS } from "../../WizardContainer/WizardContainer.types";
import type { IssueSummaryPopoverProps } from "./IssueSummaryPopover.types";
import { useIssueSummaryPopoverViewModel } from "./IssueSummaryPopover.vm";

// ============================================================================
// Component
// ============================================================================

export function IssueSummaryPopover(props: IssueSummaryPopoverProps) {
	const vm = useIssueSummaryPopoverViewModel(props);

	if (vm.issueCount === 0) return null;

	const StepIcon = WIZARD_STEP_ICONS[props.currentStep];

	return (
		<>
			<Chip
				label={`See All (${vm.issueCount})`}
				size="small"
				color="warning"
				variant="outlined"
				onClick={vm.handleOpen}
				aria-label={`View ${vm.issueCount} issues for this step`}
				aria-expanded={vm.isOpen}
				sx={{ cursor: "pointer" }}
			/>
			<Popover
				open={vm.isOpen}
				anchorEl={vm.anchorEl}
				onClose={vm.handleClose}
				anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
				transformOrigin={{ vertical: "top", horizontal: "left" }}
			>
				<Box
					sx={{
						maxHeight: 400,
						overflowY: "auto",
						minWidth: 280,
						p: 1,
						display: "flex",
						flexDirection: "column",
						gap: 1,
					}}
				>
					{vm.items.map((item) => (
						<Card key={item.issueId} variant="outlined" sx={{ opacity: item.isSkipped ? 0.5 : 1 }}>
							<CardActionArea onClick={() => vm.handleIssueClick(item)}>
								<CardContent sx={{ py: 1, "&:last-child": { pb: 1 } }}>
									<Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
										<StepIcon color="warning" sx={{ fontSize: 18 }} />
										<Typography variant="body2" fontWeight={500}>
											{item.description}
										</Typography>
										{item.isSkipped && (
											<Chip label="Ignored" size="small" sx={{ height: 18, fontSize: 10, ml: "auto" }} />
										)}
									</Box>
									{item.jobs.map((j, idx) => (
										<Typography key={idx} variant="caption" color="text.secondary" component="div">
											{[j.grower, j.farm, j.field].filter(Boolean).join(" / ")}
										</Typography>
									))}
								</CardContent>
							</CardActionArea>
						</Card>
					))}
				</Box>
			</Popover>
		</>
	);
}
